export interface KagiReversalUnitOption {
  title: string;
  sharpCharts2Id: string;
  defaultKagiReversalValue: string;
};

export const KAGI_REVERSAL_UNIT_POINTS: KagiReversalUnitOption = {
  title: 'Points',
  sharpCharts2Id: 'point',
  defaultKagiReversalValue: '1'
};

export const KAGI_REVERSAL_UNIT_PERCENTAGE: KagiReversalUnitOption = {
  title: 'Percentage',
  sharpCharts2Id: 'percent',
  defaultKagiReversalValue: '0.5'
};

export const KAGI_REVERSAL_UNIT_ATR: KagiReversalUnitOption = {
  title: 'ATR',
  sharpCharts2Id: 'atr',
  defaultKagiReversalValue: '14'
};

export const DEFAULT_KAGI_REVERSAL_UNIT: KagiReversalUnitOption = KAGI_REVERSAL_UNIT_ATR;

export const KAGI_REVERSAL_UNITS_ARRAY: KagiReversalUnitOption[] = [
  KAGI_REVERSAL_UNIT_POINTS,
  KAGI_REVERSAL_UNIT_PERCENTAGE,
  KAGI_REVERSAL_UNIT_ATR
];
